export const ROUTE_EMAILS = '/emails'
export const ROUTE_TICKETS = '/tickets'
export const ROUTE_KEYWORDS = '/keywords'
export const ROUTE_LOGIN = '/login'
export const ROUTE_RESET_PASSWORD = '/login/reset-password'

export const CONTACT_EMAIL = process.env.CONTACT_EMAIL
export const MAX_INPUT_LENGTH = 100
